import { toQuerystringFromObject } from './apiUtil';
const CustomerGroupApi = (apiClient) => ({
  importCustomerFromFile: (payload) => {
    return apiClient.post(`groupCustomer/importCustomers`, payload);
  },
});

export default CustomerGroupApi;
